class DetailsDisclosure extends HTMLElement {
  constructor() {
    super()
    console.log("[v0] DetailsDisclosure constructor called")
    this.mainDetailsToggle = this.querySelector("details")
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling

    if (!this.mainDetailsToggle || !this.content) {
      console.log("[v0] ERROR: Missing required elements", {
        details: !!this.mainDetailsToggle,
        content: !!this.content,
      })
      return
    }

    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this))
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this))
    console.log("[v0] Event listeners added successfully")
  }

  onFocusOut() {
    console.log("[v0] onFocusOut triggered")
    setTimeout(() => {
      if (!this.contains(document.activeElement) && !this.mainDetailsToggle.matches(":hover")) {
        console.log("[v0] Closing dropdown - focus moved outside")
        this.close()
      } else {
        console.log("[v0] Focus still inside or hovering, keeping open")
      }
    }, 100) // Added 100ms delay to allow for focus transitions
  }

  onToggle() {
    console.log("[v0] onToggle triggered, open:", this.mainDetailsToggle.hasAttribute("open"))

    try {
      if (!this.animations) {
        this.animations = this.content.getAnimations()
        console.log("[v0] Animations initialized:", this.animations.length)
      }

      if (this.mainDetailsToggle.hasAttribute("open")) {
        console.log("[v0] Playing animations")
        this.animations.forEach((animation) => animation.play())
      } else {
        console.log("[v0] Cancelling animations")
        this.animations.forEach((animation) => animation.cancel())
      }
    } catch (error) {
      console.log("[v0] ERROR in onToggle:", error)
    }
  }

  close() {
    console.log("[v0] close() called")
    this.mainDetailsToggle.removeAttribute("open")
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false)
  }
}

if (!customElements.get("details-disclosure")) {
  customElements.define("details-disclosure", DetailsDisclosure)
}

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super()
    this.header = document.querySelector(".header-wrapper")
  }

  onToggle() {
    if (!this.header) return
    this.header.preventHide = this.mainDetailsToggle.open

    if (document.documentElement.style.getPropertyValue("--header-bottom-position-desktop") !== "") return
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    )
  }
}

if (!customElements.get("header-menu")) {
  customElements.define("header-menu", HeaderMenu)
}
